/**
 * @flow
 * Created by neo on 13.03.17.
 */
import {observer} from 'mobx-react';
import React, {Component} from 'react';
import {Input} from 'reactstrap';
import FlightRequestRequest from "../../Store/FlightRequest/FlightRequestRequest";
import Aircraft from "../../Store/Aircraft";
import { translate  } from 'react-i18next';

type Props = {
  selected: Aircraft,
  aircrafts: Array<Aircraft>,
  onAircraftChanged: (aircraft: Aircraft) => void
};

@observer
class AircraftSelect extends Component {

  props: Props;

  selectAircraft = (aircraftModelId: string) => {
    const aircraftModel = aircraftModelId !== "" ? new Aircraft(this.props.aircrafts.find(a => a.id == aircraftModelId)) : null;
    this.props.onAircraftChanged(aircraftModel);
  };

  getAircraftMedia() {
    if(this.props.selected && this.props.selected.files && this.props.selected.files.length > 0) {
      return this.props.selected.files[0].file.url;
    }
    return null;
  }

  render() {

    let mediaTag = null;

    if(this.props.selected) {
      const media = this.getAircraftMedia();

      if (media) {
        const imageStyle = {backgroundImage: `url('${media}')`};

        mediaTag = (
          <div className="mt-2 mb-2">
            <div className="image" style={imageStyle}></div>
          </div>
        );
      }
    }

    return (
      <div className="aircraft-select">
        <Input type="select" value={this.props.selected ? this.props.selected.id : ''} onChange={e => this.selectAircraft(e.target.value)}>
          <option value="">{''}</option>

          {this.props.aircrafts.map((a, i) => {
            return (
              <option key={i} value={a.id}>{a.name}</option>
            )
          })}
        </Input>
        {mediaTag}
      </div>
    );
  }
}

export default translate ()(AircraftSelect);



// WEBPACK FOOTER //
// ./src/App/FlightRequest/View/AircraftSelect.js